
import { checkExclusionRules } from '~~/helpers/extraGuarantee/exclusionRules';
import type { ExcludedRelation } from '~~/types/extraGuarantee/ExcludedRelations';
import { getRawAttributeAsArray } from '~~/helpers/product/getRawAttributeAsArray';
import { EXTRA_GUARANTEE_ATTRIBUTES } from '~~/constants/extraGuarantee';
import { isAWareProduct } from '~~/helpers/product/productCondition';
import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';

export const useExtraGuaranteeExcluded = () => {

  const { languageAndCountry } = useLocalization();
  const { productsExtraGuarantee } = useProductsExtraGuaranteeStore();
  const { isExtraGuaranteeEnabled } = useStoreVsfExtended();

  const getExcludedSkus = (product: ProductVariantExtended): string[] => {

    return getRawAttributeAsArray(product, EXTRA_GUARANTEE_ATTRIBUTES.EXCLUDED_SKUS);
  
  };
  const getExcludedBrands = (product: ProductVariantExtended): string[] => {

    return getRawAttributeAsArray(product, EXTRA_GUARANTEE_ATTRIBUTES.EXCLUDED_BRANDS);
  
  };
  const getExcludedRelations = (product: ProductVariantExtended): ExcludedRelation[] => {

    return getRawAttributeAsArray(product, EXTRA_GUARANTEE_ATTRIBUTES.EXCLUDED_RELATIONS);
  
  };

  const getGuaranteesForProduct = (product: Maybe<ProductVariantExtended>): ProductVariantExtended[] => {

    if (
      !isExtraGuaranteeEnabled.value ||
      !productsExtraGuarantee.value?.length ||
      !isAWareProduct(product?.sku,
      )) {

      return [];
    
    }

    return productsExtraGuarantee.value?.filter(extraGuaranteeProduct =>
      !checkExclusionRules(
        product,
        languageAndCountry.value,
        {
          excludedSkus: getExcludedSkus(extraGuaranteeProduct),
          excludedBrands: getExcludedBrands(extraGuaranteeProduct),
          excludedRelations: getExcludedRelations(extraGuaranteeProduct),
        },
      ),
    ) || [];
  
  };

  const isGuaranteeExcluded = (product: Maybe<ProductVariantExtended>): boolean => {

    return !getGuaranteesForProduct(product).length;
  
  };

  return {
    getGuaranteesForProduct,
    isGuaranteeExcluded,
  };

};
